import { createSelector } from "reselect";
const merchant = (state : any ) => state.merchant;
const merchantId = (state: any) => state.analytics.merchant_id
const analytic = (state : any) => state.analytics;
const analytics_metric = (state:any) =>state.analytics_metric;
const user = (state: any) => state.user;


export const merchants = createSelector(
  merchant,
  merchant => {
    return merchant
  }
)

export const currentMerchantName = createSelector(
  merchants, merchantId,
  (merchants: any, merchantId: number) => {
    const merchant = merchants.find((merchant: any) => merchant.id == merchantId)
    if (merchant) return merchant.name
    return ''
  }
)

export const globalFilters = createSelector(
    analytic,
    (analytic) => {
        return analytic.globalFilters
    }
)

export const getViewContext = createSelector(
  globalFilters, analytics_metric, analytic,
  (filters, analytics_metric, analytic) => {
    const {group_by, compare_by, view} = analytics_metric
    const {start_date, end_date, publication_ids, metrics_container_tab}  = analytic
    const metric = metrics_container_tab
    const viewContext = {
      metric: metric,
      groupBy: group_by,
      compareBy: compare_by,
      view: view,
      startDate: start_date,
      endDate: end_date,
      numPublications: publication_ids ? publication_ids.length.toString() : '0',
      deviceFilters: filters.device.join(', '),
      channelFilters: filters.channel.join(', ')
    }
    return viewContext
  }
)

export const getUserCapabilities = createSelector(
  user,
  (user) => {
    const {permissions, features} = user
    return {permissions,features}
  }
)

export const getMetric = createSelector(
  analytic,
  (analytic) => {
    return analytic.metrics_container_tab
  }
)


// WEBPACK FOOTER //
// ./client/modules/Analytics/selectors.ts